import { DataLoadURL } from '@workflow/ecp-shared/model/dataload-url';

export const User_api = {
  ForgotPassword: {
    hostName: 'consumerPortalApi',
    method: 'GET',
    url: 'account/forgotpassword'
  } as DataLoadURL,
  ResetPassword: {
    defaultHeaders: { 'content-type': 'application/json' },
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'account/passwordreset'
  } as DataLoadURL,
  UserExists: {
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'account/exists'
  } as DataLoadURL,
  LogIn: {
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'account/login'
  } as DataLoadURL,
  LogOut: {
    hostName: 'consumerPortalApi',
    method: 'DELETE',
    url: 'account/logout'
  } as DataLoadURL,
  RefreshToken: {
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'account/refreshtoken'
  } as DataLoadURL,
  Register: {
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'account/register'
  } as DataLoadURL,
  UpdateSettings: {
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'account/settings'
  } as DataLoadURL,
  StartNewApplication: {
    defaultHeaders: { 'content-type': 'application/json' },
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'consumer/dynamic/bundle?oao'
  } as DataLoadURL,
  LinkLoan: {
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'account/linkloan'
  } as DataLoadURL
};
